module.exports = __webpack_public_path__ + "img/admin_icon.8dbad083.svg";